module.exports = __webpack_public_path__ + "static/imdalogo-efdf0e45637ef490f1b20ae8d270c60e.png";